import { useNavigate } from "react-router-dom";
import paths from "../../../utils/paths";
import styles from "./AdvocateCard.module.css";
import {
  calculateExperience,
  getCloudinaryAvatar,
} from "../../../utils/commonUtils";

export default function AdvocateCard({
  advocateId,
  profileImg,
  fullName,
  email,
  experience,
  startedYear,
  country,
}) {
  const navigate = useNavigate();
  return (
    <div
      key={advocateId}
      className={`${styles.panelCard} p-3 h-full d-flex flex-column flex-md-row align-items-md-center overflow-hidden card-shadow`}
      onClick={() => navigate(`${paths.Arbitrators}/` + advocateId)}
    >
      <div className="">
        <img
          className={styles.advocateProfileImg}
          src={
            getCloudinaryAvatar(profileImg, 70) ||
            "https://res.cloudinary.com/dapljmrfe/image/upload/v1738408387/mhlkd4uc8strhaarznzk.jpg"
          }
          alt="person"
        />
      </div>
      <div>
        <h3>{!fullName ? email?.split("@")[0] : fullName}</h3>
        <div className={styles.panelCardContent}>
          <p>
            <i className="ri-auction-fill"></i>
            {/* {experience} */}
            {calculateExperience(startedYear) || 1} Years
          </p>
          <p>
            <i className="ri-map-pin-2-line"></i> {country}
          </p>
        </div>
      </div>
    </div>
  );
}
